export interface Point { x: number; y: number }

export enum LocationAreaType {
  completed = 'completed',
  planned = 'planned',
}
